import AddBoxIcon from '@mui/icons-material/AddBox';
import Button from '@mui/material/Button';
import '../../pages/pages.scss';

const PageHeader = ({ title, includeCreate, createTitle, onCreate }) => {
    return (
      <div id="headerContainer" className="headerContainer">
        <div id="pageHeader" className="pageHeaderContainer">
          <div id="content-left" className="content-left">
            <div id="pageTitle" className="pageTitle">{title}</div>
            {includeCreate && <div id="subhead" className="subhead">
              <Button variant="text" endIcon={<AddBoxIcon color="primary" />} className="subheadText" onClick={onCreate}>{createTitle}</Button>
            </div>
            }
  
          </div>
        </div>
      </div>
    )
  }


  export default PageHeader;